import React, { useEffect, useState } from 'react';

let throttle_resize;
const preview_padding = 15;

const PreviewWrapperNotBuilder = (props) => {
	const device_preview = props?.device_preview ?? 'iPhone6';
	const [ scale, setScale ] = useState(1);

	useEffect(() => {
		adaptToContainer();
		window.addEventListener('resize', adaptToContainer);

		return () => {
			window.removeEventListener('resize', adaptToContainer);
		}
	}, []);

	const adaptToContainer = () => {
		if(throttle_resize != undefined) clearTimeout(throttle_resize);

		throttle_resize = setTimeout(() => {
			const prop_scale_w = ($('.device_area').width() - 9) / (parseInt($('.gui_preview_contents').outerWidth() + 2 * preview_padding));
			const prop_scale_h = ($('.device_area').height() - 9) / (parseInt($('.gui_preview_contents').outerHeight() + 2 * preview_padding));
			setScale(Math.max(Math.min(1, prop_scale_w, prop_scale_h), 0.4));	// max: 100%, min: 40%
		}, 150);
	};

	const is_fullscreen = props?.is_fullscreen ?? false;

	return (
		<div class={'previewAlike gui_pos_rel' + ((is_fullscreen) ? ' whole_height' : '')}>
			<div class="conts">
				<div class="device_area">
					<div class="preview_container gui_not_bordered gui_hidden_overflowed without_footer_menu">
						<div class={`gui_preview_contents gui_pos_rel ${device_preview}_portrait`} style={{minHeight:'100%', width:'100%', transform:`scale(${scale})`}}>
							<div class="preview_contents">
								{(props.url != undefined) ? (
									<iframe id="promotion_preview" src={props.url} />
								) : (
									props.children
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default PreviewWrapperNotBuilder;